import React, { useState, useEffect, forwardRef, useImperativeHandle} from "react";
import {
  Modal,
  Button,
  Space,
  Descriptions,
} from "antd";
import { HomeOutlined, } from "@ant-design/icons";
import moment from "moment";
import http from "@/utils/http";
import api from "@/utils/api";
import commonFn from "@/utils/commonFn";
import { CustomTable, } from "@/hocComponents";

const EditHistoryModal = forwardRef(({ }, ref) => {
  const [modalName, setModalName] = useState('');
  const [modalFlag, setModalFlag] = useState(false);

  const initTableHead = {};
  const [tableHead, setTableHead] = useState(initTableHead);
  const [tableList, setTableList] = useState([]);
  const [tableLoading, setTableLoading] = useState(false);

  const tableFilterFn = (event, key, type = "Input") => {
    commonFn.tableFilterFn({
      event,
      key,
      type,
      setTableHead,
      getTableListFn,
    });
  };

  const initColumns = [
    {
      title: '#',
      dataIndex: '#',
    },
    {
      title: "User",
      dataIndex: "accountName",
      titleType: "",
    },
    {
      title: 'Edit Time',
      dataIndex: "operatorTime",
      titleType: '',
      isSorter: false,
    },
  ];

  const [columns, setColumns] = useState(initColumns);
  
  useImperativeHandle(ref, () => ({
    openModal: ({modalName, type, id}) => {
      setModalFlag(false)
      setModalName(modalName)
      setTableHead({
        ...initTableHead,
        type,
        id
      })
      setModalFlag(true)
    }
  }));

  const afterOpenChangeFn = (flag) => {
    if(flag){
      getTableListFn()
    }else{
      setTableHead({})
      setTableList([])
      setTableLoading(false);
    }
  }

  const getTableListFn = async() => {
    setTableLoading(true);
    const response = await http.get(api.operatorRecords, {params: {...tableHead }});
    if (response?.code !== "1") {
      commonFn.modalFailedFn(response);
      setTableList([])
      setTableLoading(false);
      return;
    }
    setTableList(response?.data || []);
    setTableLoading(false);
  }

  return (
    <Modal
        title={
          <div style={{ fontSize: "24px", fontWeight: "bold", color: "#3c8dbc" }}>
            <HomeOutlined style={{ marginRight: "8px" }} />
            {modalName}
            <div
              style={{ borderTop: "3px solid #3c8dbc", marginTop: "8px" }}
            ></div>
          </div>
        }
        centered
        open={modalFlag}
        onCancel={() => setModalFlag(false)}
        footer={null}
        maskClosable={false}
        afterOpenChange={afterOpenChangeFn}
        width="80%"
      >
        <CustomTable
          tableLoading={tableLoading}
          rowKey="vendorPaymentId"
          columns={columns}
          tableList={tableList}
          pagination={false}
          handleTableChange={() => {}}
          tableScrollYAll="calc(80vh - 200px - 100px)"
        />
        {/* <div style={{textAlign:'center', marginTop: '30px'}}>
          <Space align="center">
            <Button key="back" onClick={() => setModalFlag(false)}>
              Cancel
            </Button>
          </Space>
        </div> */}
      </Modal>
  );
});

export default EditHistoryModal;
